import { cognitoConfig } from "./cognitoConfig";

const loginWithCognito = () => {
  const {
    domain,
    clientId,
    redirectUri,
    responseType,
    scope,
    provider,
  } = cognitoConfig;

  const url = `https://${domain}/oauth2/authorize` +
    `?identity_provider=${provider}` +
    `&response_type=${responseType}` +
    `&client_id=${clientId}` +
    `&redirect_uri=${encodeURIComponent(redirectUri)}` +
    `&scope=${encodeURIComponent(scope)}` +
    `&prompt=select_account`;

  window.location.href = url;
};

export default loginWithCognito;